import { LoadStatus } from '@capital-access/common/utils';

export const TemplateExportInitialState = {
  exportData: [],
  loaderStatus: LoadStatus.Pristine,
  exportStatus: LoadStatus.Pristine,
  addListDrawerOpened: false,
  selectedList: [],
  commentSectionDrawerState: {
    isOpened: false,
    selectedListItem: null
  },
  filterActivitiesDrawerState: {
    isOpened: false,
    selectedListItem: null,
    companyContactLoadStatus: LoadStatus.Pristine,
    companyContacts: []
  },
  showExportWarning: true,
  showSelectWarning: true,
  exportBnySecurityId: -1,
  exportBnyReportTime: new Date(),
  exportItineraryComments: [],
  exportSucceeded: false
};
